import React from 'react';
import { useAtom } from 'jotai';
import useFlowData from '../hooks/useFlowData';
import { removeFlowAtom } from '../../atoms';
import FlowRowContent from './components/FlowRowContent';
import type { ColumnWidths } from './types';

export const RowComponent = ({
  flowMeta,
  columnWidths,
}: {
  flowMeta: any;
  columnWidths: ColumnWidths;
}) => {
  const [, removeFlow] = useAtom(removeFlowAtom);
  const flowId = flowMeta?.id || '';
  const query = useFlowData({ flowId, flowMeta });

  return (
    <FlowRowContent
      flowMeta={flowMeta}
      query={query}
      removeFlow={removeFlow}
      columnWidths={columnWidths}
    />
  );
};
